export default __webpack_public_path__ + "static/media/image-grid-hearts.9c89c175.png";